import { render, staticRenderFns } from "./shopPurchaseInfos.vue?vue&type=template&id=6a0ef18d"
import script from "./shopPurchaseInfos.vue?vue&type=script&lang=js"
export * from "./shopPurchaseInfos.vue?vue&type=script&lang=js"
import style0 from "./shopPurchaseInfos.vue?vue&type=style&index=0&id=6a0ef18d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports